import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";

// A lost PUT response does not prove the save failed. Check the stored record
// before the user can retry an operation that may have already committed.
export async function confirmATKSave(recordId, onboardingData, headers) {
  try {
    const response = await axios.get(`${ApiLink.API_URL}FiscalCashRegister`, { headers });
    const record = (response.data || []).find(item => Number(item.Id) === Number(recordId));
    if (!record) return "not_saved";
    const saved = record.ATKPrivateKeyPemEncrypted === onboardingData.atkPrivateKeyPemEncrypted &&
      record.ATKSignedCertificatePem === onboardingData.atkSignedCertificatePem &&
      Number(record.ATKPOSID) === Number(onboardingData.atkPOSID) &&
      Number(record.ATKBranchID) === Number(onboardingData.atkBranchID);
    return saved ? "saved" : "not_saved";
  } catch {
    return "unknown";
  }
}
